import { CommonEnums } from '../../common.enums';

export class DxMp_Inst {
    dxMp_Inst_Id: number;
    dxFlow_Id: number;
    instNm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxMp_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    conn_Id: number;
    conn_Nm: string;
    dbTyp_Id: number;
    spark_dsa: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dxMp_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.instNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg == CommonEnums.defaults.STRING_VAL_NO;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.spark_dsa = CommonEnums.defaults.STRING_VAL_NO;
        this.retryEnabled = CommonEnums.defaults.STRING_EMPTY;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
    }

    getPrimaryKey(): string {
        return this.dxMp_Inst_Id + '.' + this.dxFlow_Id;
    }

    copy(): DxMp_Inst {
        let dxMp_InstTmp: DxMp_Inst = new DxMp_Inst();

        dxMp_InstTmp.dxMp_Inst_Id = this.dxMp_Inst_Id;
        dxMp_InstTmp.dxFlow_Id = this.dxFlow_Id;
        dxMp_InstTmp.instNm = this.instNm;
        dxMp_InstTmp.description = this.description;
        dxMp_InstTmp.ver = this.ver;
        dxMp_InstTmp.valid_Cd = this.valid_Cd;
        dxMp_InstTmp.dxMp_Id = this.dxMp_Id;
        dxMp_InstTmp.updateBy = this.updateBy;
        dxMp_InstTmp.lastUpdateBy = this.lastUpdateBy;
        dxMp_InstTmp.updateDt = this.updateDt;
        dxMp_InstTmp.disableFlg = this.disableFlg;
        dxMp_InstTmp.conn_Id = this.conn_Id;
        dxMp_InstTmp.conn_Nm = this.conn_Nm;
        dxMp_InstTmp.dbTyp_Id = this.dbTyp_Id;
        dxMp_InstTmp.spark_dsa = this.spark_dsa;
        dxMp_InstTmp.retryEnabled = this.retryEnabled;
        dxMp_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        dxMp_InstTmp.retryWaitTime = this.retryWaitTime;

        return dxMp_InstTmp;
    }

    copyFrom(dxMp_InstTmp: DxMp_Inst): void {
        this.dxMp_Inst_Id = dxMp_InstTmp.dxMp_Inst_Id;
        this.dxFlow_Id = dxMp_InstTmp.dxFlow_Id;
        this.instNm = dxMp_InstTmp.instNm;
        this.description = dxMp_InstTmp.description;
        this.ver = dxMp_InstTmp.ver;
        this.valid_Cd = dxMp_InstTmp.valid_Cd;
        this.dxMp_Id = dxMp_InstTmp.dxMp_Id;
        this.updateBy = dxMp_InstTmp.updateBy;
        this.lastUpdateBy = dxMp_InstTmp.lastUpdateBy;
        this.updateDt = dxMp_InstTmp.updateDt;
        this.disableFlg = dxMp_InstTmp.disableFlg;
        this.conn_Id = dxMp_InstTmp.conn_Id;
        this.conn_Nm = dxMp_InstTmp.conn_Nm;
        this.dbTyp_Id = dxMp_InstTmp.dbTyp_Id;
        this.spark_dsa = dxMp_InstTmp.spark_dsa;
        this.retryEnabled = dxMp_InstTmp.retryEnabled;
        this.numOfRetryAttempts = dxMp_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = dxMp_InstTmp.retryWaitTime;
    }

    compare(dxMp_InstTmp: DxMp_Inst): string {
        let dxMp_InstString: string = this.toString(false);
        let dxMp_InstTmpString: string = dxMp_InstTmp.toString(false);

        if (dxMp_InstString != dxMp_InstTmpString) {
            return dxMp_InstString + ', ' + dxMp_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DxMp_Inst [dxMp_Inst_Id=" + this.dxMp_Inst_Id +
            ", dxFlow_Id=" + this.dxFlow_Id +
            ", instNm=" + this.instNm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", valid_Cd=" + this.valid_Cd +
            ", dxMp_Id=" + this.dxMp_Id +
            ", updateBy=" + this.updateBy +
             ", updateDt =" + this.updateDt +
            ", disableFlg =" + this.disableFlg +
            ", conn_Id =" + this.conn_Id +
            ", spark_dsa =" + this.spark_dsa +
            ", retryEnabled = " + this.retryEnabled +
            ", numOfRetryAttempts =" + this.numOfRetryAttempts +
            ", retryWaitTime = " + this.retryWaitTime;

        if (isNotCompare) {
            str += ", lastUpdateBy=" + this.lastUpdateBy +
            ",conn_Nm ="+ this.conn_Nm +
            ",dbTyp_Id =" + this.dbTyp_Id;
        }

        str += ']';
        return str;
    }
}